export default {
  colors: {

  },
  paths: {
    apiDomain: '/api',
    cloudDomain: '',
    appPath: 'https://ittec-pm.com/',
    shopPath: 'http://195.35.2.220:8080/shop/',
  }
}
